import React from "react";
import MessengerPage from "../Components/Chat/MessengerPage";
import FlowsList from "../Components/Onboarding/Flows/FlowsList";
import ActiveOnboarding from "../Components/Onboarding/ActiveOnboarding/ActiveOnboarding";
import FormsPage from "../Components/Onboarding/Forms/FormsPage";
import DocumentCenter from "../Components/Onboarding/DocumentCenter/DocumentCenter";
import CandidatePortal from "../Components/Onboarding/CandidatePortal/CandidatePortal";
import MyAssessment from "../Components/My-assessment/myAssessment";
import SelectTest from "../Components/Test-library/Test-results/selectTest";
import AddQuestion from "../Components/Test-library/Test-results/addQuestion";
import InvitePreview from "../Components/Test-library/Test-results/invitePreview";
import CreateQuestion from "../Components/Test-library/Test-results/createQuestion";
import CandidateTest from "../Components/Candidate-Test/candidateTest";
import TestReport from "../Components/My-assessment/test-report";
import Reports from "../Components/Reports/reports";
import ReportedIssues from "../Components/Reports/reportedIssues";
import Users from "../Components/Users/user";
import Settings from "../Components/Settings/settings";
import RegisterTest from "../Components/Candidate-Test/registerTest";
import Accounts from "../Components/Settings/profile";
import TanentUsers from "../Components/TanentUser/tanentUsers";
import Main from "../utils/CodeEditor/main";
import SelectCodingTest from "../Components/Test-library/selectCodingTest";
import SelectDatabaseTest from "../Components/Test-library/SelectDatabaseTest";
import CreateCodingQuestion from "../Components/CreateCodingQuestion/createCodingQuestion";
import CreateCodeText from "../Components/CreateCodingQuestion/createCodeText";
import GappeoTest from "../Components/Gappeo Tests/gappeoTest";
import MyQuestions from "../Components/My-Questions/myQuestions";
import MyTests from "../Components/My-tests/mytests";
import AssessmentReport from "../Components/My-assessment/assessmentReport";
import Jobs from "../Components/JobPosting/jobs";
import JobsV2 from "../Components/JobPostingV2/jobsV2";
// import CreateJob from "../Components/JobPosting/createJob";
import CreateJob from "../Components/CreateJob/createJob";
import CandidateProfile from "../Components/JobPosting/candidateProfile";
import CandidateProfileV2 from "../Components/candidateProfileV2/candidateProfileV2";
import VoiceInterviewsReport from "../Components/Interview-result/voiceInterviewsReport";
import VideoInterviewsReport from "../Components/Interview-result/videoInterviewsReport";
import VideoInterview from "../Components/Video-Interview/videoInterview";
import EditJob from "../Components/JobPosting/editJob";
import CandidateUpload from "../Components/Candidate-Upload/candidateUpload";
import Dashboard from "../Components/Home/Dashboard";
import Livefeed from "../Components/Home/Livefeed";
import JobTabs from "../Components/JobPosting/jobTabs";
import Candidates from "../Components/JobPosting/candidates";
import JobTabsV2 from "../Components/JobPostingV2/jobTabsV2";
import CandidatesV2 from "../Components/JobPostingV2/candidatesV2";
import JobDetails from "../Components/JobPosting/jobDetails";
import JobSettings from "../Components/JobPosting/jobSettings";
import Automation from "../Components/JobPosting/automation";
import AutomationV2 from "../Components/JobPostingV2/automationV2";
import ApiKeys from "../Components/Settings/apiKeys";
import Companies from "../Components/Settings/companies";
import CompanyMembers from "../Components/Settings/companyMembers";
import CandidateManagement from "../Components/Candidates/candidateManagement";
import InvitedCandidates from "../Components/My-assessment/invitedCandidates";
import BillingSuccess from "../Components/Billing/Success";
import BillingCancel from "../Components/Billing/Cancel";
import Myprofile from "../Components/Users/Myprofile";
import HybridVideoInterviewMain from "../Components/HybridVideo-Interview/HybridVideoInterviewMain";
import DynamicVoiceInterviewMain from "../Components/DynamicVoice-Interview/DynamicVoiceInterviewMain";
const TestLibrary = React.lazy(() => import("../Components/Home/Home"))

const RouteItems = [
    { path: "/home", component: <TestLibrary />, layout: "mainLayout", title: "Home", letter: 'H' },
    { path: '/assessments', component: <MyAssessment />, layout: 'mainLayout', title: 'Assessments', letter: 'A' },
    { path: '/assessments/invitedCandidates', component: <InvitedCandidates />, layout: 'mainLayout', title: 'Assessments invite', letter: 'A' },
    { path: '/assessments-report', component: <AssessmentReport />, layout: 'mainLayout', title: 'Assessments Report', letter: 'A' },
    { path: '/gappeo-tests', component: <GappeoTest />, layout: 'mainLayout', title: 'Gappeo Test', letter: 'G' },
    { path: '/reports', component: <Reports />, layout: 'mainLayout', title: 'Reports', letter: 'R' },
    { path: '/reported-issues', component: <ReportedIssues />, layout: 'mainLayout', title: 'Reported Issues', letter: 'R' },
    { path: '/test-report', component: <TestReport />, layout: 'mainLayout', title: 'Test Reports', letter: 'T' },
    { path: '/plan', component: <Settings />, layout: 'mainLayout', title: 'Settings', letter: 'S' },
    { path: '/users', component: <Users />, layout: 'mainLayout', title: 'Users', letter: 'U' },
    { path: '/my-questions', component: <MyQuestions />, layout: 'mainLayout', title: 'My Questions', letter: 'Q' },
    { path: '/select-coding-test', component: <SelectCodingTest />, layout: 'mainLayout', title: 'Select Database Test', letter: 'S' },
    { path: '/select-database-test', component: <SelectDatabaseTest />, layout: 'mainLayout', title: 'Select Coding Test', letter: 'S' },
    { path: '/home/select-test', component: <SelectTest />, layout: 'mainLayout', title: 'Create Assessment', letter: 'H' },
    { path: '/home/add-question', component: <AddQuestion />, layout: 'mainLayout', title: 'Add Questions', letter: 'H' },
    { path: '/home/invite-preview', component: <InvitePreview />, layout: 'mainLayout', title: 'Invite Perview', letter: 'H' },
    { path: '/create', component: <CreateQuestion />, layout: 'mainLayout', title: 'Create Questions', letter: 'C' },
    { path: '/create-coding-question', component: <CreateCodingQuestion />, layout: 'mainLayout', title: 'Create Coding Questions', letter: 'C' },
    // { path: '/create-database-question', component: <CreateDatabaseQuestions />, layout: 'mainLayout', title: 'Create Database Questions', letter: 'C' },
    { path: '/profile', component: <Accounts />, layout: 'mainLayout', title: 'Profile', letter: 'P' },
    { path: '/tanents', component: <TanentUsers />, layout: 'mainLayout', title: 'User', letter: 'U' },
    { path: '/add-text', component: <CreateCodeText />, layout: 'mainLayout', title: 'Create code Text', letter: 'C' },
    { path: '/jobs-v1', component: <Jobs />, layout: 'mainLayout', title: 'Jobs', letter: 'J' },
    { path: '/jobs', component: <JobsV2 />, layout: 'mainLayout', title: 'Jobs', letter: 'J' },
    { path: '/candidates-management', component: <CandidateManagement />, layout: 'mainLayout', title: 'Candidates', letter: 'C' },
    { path: '/jobs/createjob', component: <CreateJob />, layout: 'mainLayout', title: 'Create Job', letter: 'J' },
    { path: '/jobs/editJob', component: <EditJob />, layout: 'mainLayout', title: 'Edit Job', letter: 'J' },
    {
        path: "/jobs/:jobId", component: <JobTabsV2 />, layout: "mainLayout",
        children: [
            { path: "candidates", component: <CandidatesV2 />, },
            { path: "details", component: <JobDetails />, },
            { path: "settings", component: <JobSettings />, },
            { path: "automation", component: <AutomationV2 />, },
        ],
    },
    {
        path: "/jobs-v1/:jobId", component: <JobTabs />, layout: "mainLayout",
        children: [
            { path: "candidates", component: <Candidates />, },
            { path: "details", component: <JobDetails />, },
            { path: "settings", component: <JobSettings />, },
            { path: "automation", component: <Automation />, },
        ],
    },
    { path: '/jobs/:jobId/candidates/:candidateId', component: <CandidateProfileV2 />, layout: 'mainLayout', title: 'Candidates Profile', letter: 'J' },
    { path: '/jobs-v1/:jobId/candidates/:candidateId', component: <CandidateProfile />, layout: 'mainLayout', title: 'Candidates Profile', letter: 'J' },
    { path: '/voice-interviews-report', component: <VoiceInterviewsReport />, layout: 'mainLayout', title: 'Voice Interview', letter: 'V' },
    { path: '/video-interviews-report', component: <VideoInterviewsReport />, layout: 'mainLayout', title: 'Video Interview', letter: 'V' },
    { path: '/dashboard', component: <Dashboard />, layout: 'mainLayout', title: 'Dashboard', letter: 'D' },
    { path: '/dashboard/live-feed', component: <Livefeed />, layout: 'mainLayout', title: 'Live Feed', letter: 'L' },
    { path: '/keys', component: <ApiKeys />, layout: 'mainLayout', title: 'KPI Keys', letter: 'A' },
    { path: '/companies', component: <Companies />, layout: 'mainLayout', title: 'Companies', letter: 'C' },
    { path: '/company-members', component: <CompanyMembers />, layout: 'mainLayout', title: 'Company Members', letter: 'C' },
    { path: '/billing/success', component: <BillingSuccess />, layout: 'mainLayout', title: 'Billing Success', letter: 'B' },
    { path: '/billing/cancel', component: <BillingCancel />, layout: 'mainLayout', title: 'Billing Cancel', letter: 'B' },
    {path: '/my-profile', component: <Myprofile />, layout: 'mainLayout', title: 'My profile', letter: 'M'},

    { path: '/candidate-test/:token', component: <CandidateTest />, layout: 'candidate-layout' },
    { path: '/candidate-invite-test/:token', component: <RegisterTest />, layout: 'candidate-layout' },
    { path: '/coding-test', component: <Main />, layout: 'candidate-layout' },
    { path: '/my-tests', component: <MyTests />, layout: 'mainLayout', title: 'My Test', letter: 'T' },
    { path: '/video-call/:token', component: <VideoInterview />, layout: 'videoInterview-layout' },
    { path: '/video-call/hybrid/:token', component: <HybridVideoInterviewMain />, layout: 'hybridVideoInterview-layout' },
    { path: '/dynamic-voice-call/:token', component: <DynamicVoiceInterviewMain />, layout: 'dynamicVoiceInterview-layout' },
    { path: '/jobs/:jobId/apply', component: <CandidateUpload />, layout: 'candidate-upload' },

    // Onboarding routes (mainLayout)
    { path: '/onboarding/flows', component: <FlowsList />, layout: 'mainLayout', title: 'Onboarding Flows', letter: 'O' },
    { path: '/onboarding/active', component: <ActiveOnboarding />, layout: 'mainLayout', title: 'Active Onboarding', letter: 'O' },
    { path: '/onboarding/forms', component: <FormsPage />, layout: 'mainLayout', title: 'Onboarding Forms', letter: 'O' },
    { path: '/onboarding/documents', component: <DocumentCenter />, layout: 'mainLayout', title: 'Document Center', letter: 'O' },

    // Candidate portal (separate layout)
    { path: '/onboarding/portal', component: <CandidatePortal />, layout: 'onboarding-portal-layout' },

    // Messenger (recruiter inbox)
    { path: '/messenger', component: <MessengerPage />, layout: 'mainLayout', title: 'Messenger', letter: 'M' },
]

export default RouteItems;